import * as React from 'react';
import { newsBondCurrentPageContext } from './context';
import { useLocalizedSanityNewsBondsByUrlIdWithoutInvalid } from '../../../../../../../../../../../../../../../../../../sanity';

export const NewsBondCurrenPageProvider = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const pageHandlers = React.useState(0);
  const {
    data,
  } = useLocalizedSanityNewsBondsByUrlIdWithoutInvalid();
  const length = data?.length;
  React.useEffect(() => {
    if (length != null) {
      const [currentPage, setCurrentPage] = pageHandlers;
      if (currentPage >= length - 1) {
        setCurrentPage(length - 1);
      }
      if (length < 0) {
        setCurrentPage(0);
      }
    }
  }, [length, pageHandlers]);
  return (
    <newsBondCurrentPageContext.Provider
      value={pageHandlers}
    >
      {children}
    </newsBondCurrentPageContext.Provider>
  );
};
